import React, { useState, useEffect } from 'react';
import { useTranslation } from '../context/LanguageContext';
import './Modal.css';

interface AdminCancelAppointmentDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: (countTowardLimit: boolean) => void;
  onCancel: () => void;
}

const AdminCancelAppointmentDialog: React.FC<AdminCancelAppointmentDialogProps> = ({
  isOpen,
  isLoading = false,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation();
  const [countTowardLimit, setCountTowardLimit] = useState(false);

  // Reset the checkbox each time the dialog is opened for a new appointment
  useEffect(() => {
    if (isOpen) {
      setCountTowardLimit(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={isLoading ? undefined : onCancel}>
      <div className="modal-content confirmation-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <span className={`confirmation-icon ${isLoading ? 'loading' : ''}`}>{isLoading ? '⏳' : '⚠️'}</span>
            {t('cancelAppointment')}
          </h3>
        </div>

        <div className="confirmation-body">
          <p>{t('confirmCancelAppointmentMessage')}</p>
          <div className="checkbox-group" style={{ marginTop: '16px', marginBottom: 0 }}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={countTowardLimit}
                disabled={isLoading}
                onChange={(e) => setCountTowardLimit(e.target.checked)}
              />
              <span className="checkbox-text">{t('cancelCountsTowardLimit')}</span>
            </label>
          </div>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onCancel} className="btn-secondary" disabled={isLoading}>
            {t('cancelText')}
          </button>
          <button type="button" onClick={() => onConfirm(countTowardLimit)} className="btn-danger" disabled={isLoading}>
            {isLoading ? `${t('loading')}...` : t('cancelAppointment')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminCancelAppointmentDialog;
